import { render, staticRenderFns } from "./ReasonForArchiving.vue?vue&type=template&id=42feb628&scoped=true"
import script from "./ReasonForArchiving.vue?vue&type=script&setup=true&lang=js"
export * from "./ReasonForArchiving.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42feb628",
  null
  
)

export default component.exports